<div class="website-parent-container">
  <div class="website-container">
    <div class="website-container-header">
      ArogyaLine Production Links
    </div>
    <div>
      <a href="https://www.arogyaline.com"
          target="_blank"
          rel="noopener noreferrer">
          <span>ArogyaLine</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.arogyaline.com)</span>
    </div>
    <div>
      <a href="https://www.doctors.arogyaline.com"
          target="_blank"
          rel="noopener noreferrer">
          <span>ArogyaLine Doctors</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.doctors.arogyaline.com)</span>
    </div>
    <div>
      <a href="https://www.sales.arogyaline.com"
          target="_blank"
          rel="noopener noreferrer">
          <span>ArogyaLine Sales</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.sales.arogyaline.com)</span>
    </div>
  </div>

  <div class="website-container">
    <div class="website-container-header">
      ArogyaLine Test Links
    </div>
    <div>
      <a href="https://www.staging02.arogyaline.com"
          target="_blank"
          rel="noopener noreferrer">
          <span>ArogyaLine</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.staging02.arogyaline.com)</span>
    </div>
    <div>
      <a href="https://www.staging02.doctors.arogyaline.com"
          target="_blank"
          rel="noopener noreferrer">
          <span>ArogyaLine Doctors</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.staging02.doctors.arogyaline.com)</span>
    </div>
    <div>
      <a href="https://www.staging02.sales.arogyaline.com"
          target="_blank"
          rel="noopener noreferrer">
          <span>ArogyaLine Sales</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.staging02.sales.arogyaline.com)</span>
    </div>
  </div>

  <div class="website-container">
    <div class="website-container-header">
      Food Express Links
    </div>
    <div>
      <a href="https://www.foodexpress.arogyamm.in"
          target="_blank"
          rel="noopener noreferrer">
          <span>Food Express</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.foodexpress.arogyamm.in)</span>
    </div>
    <div>
      <a href="https://www.admin.foodexpress.arogyamm.in"
          target="_blank"
          rel="noopener noreferrer">
          <span>Food Express Admin</span>
          <app-icon [item]="externalLinkIcon"></app-icon>
      </a>
      <span class="link-description">(https://www.admin.foodexpress.arogyamm.in)</span>
    </div>
  </div>
</div>